import React, { type ComponentType, type ReactNode, Suspense } from "react";

import { Loading } from "@/components/loading";

interface LazyRoutePropsWithChildren {
	children: ReactNode;
	Component?: never;
}

interface LazyRoutePropsWithComponent {
	children?: never;
	Component: React.LazyExoticComponent<ComponentType>;
}

export type LazyRouteProps = LazyRoutePropsWithChildren | LazyRoutePropsWithComponent;

export const LazyRoute: React.FC<LazyRouteProps> = ({ children, Component }) => {
	if (children) {
		return <Suspense fallback={<Loading data-testid="lazy-route-loading" />}>{children}</Suspense>;
	}

	if (Component) {
		return (
			<Suspense fallback={<Loading data-testid="lazy-route-loading" />}>
				<Component />
			</Suspense>
		);
	}

	return null;
};
